import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { JwtModule } from '@auth0/angular-jwt';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { getItemFromLocalStorage } from '../core/services/local-storage.service';
import { META_REDUCERS } from '../core/store/reducers';
import { SharedModule } from '../shared/shared.module';
import { ROUTES } from './auth.routes';
import { authFeatureFlags, JWT_DISALLOWED_ROUTES } from './consts/auth.consts';
import { EFFECTS, reducers } from './store';

function tokenGetter(): string | null {
  return (
    getItemFromLocalStorage('access_token') ??
    globalThis.localStorage.getItem('access_token') ??
    null
  );
}

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(ROUTES),
    JwtModule.forRoot({
      config: {
        tokenGetter,
        allowedDomains: environment.allowedDomains,
        disallowedRoutes:
          authFeatureFlags.isAccessTokenRefreshEnabled ?
            JWT_DISALLOWED_ROUTES
          : [],
      },
    }),
    StoreModule.forFeature('auth', reducers, { metaReducers: META_REDUCERS }),
    EffectsModule.forFeature(EFFECTS),
  ],
})
export class AuthModule {}
